import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import '../../../static/css/pages/sci/sci.css';
import {Link} from "react-router-dom";
import {ChevronRightIcon, SearchIcon, ThinTimeIcon, TomansIcon} from "../../../components/icons/material-icons";
import {AuthRedirectParents, PostJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {TimeFixToGoLayout} from "../../../components/techaran/date-convert";

export interface sciClassInterface {
    nd: string,
    title: string,
    desc: string,
    img: string,
    teacher: string,
    price: number,
    isWorkshop: 0 | 1,
    hasExpiration: 0 | 1,
    expiresAt: string,
}

export const StudentsCenterScreen = () => {
    const [loaded, setLoaded] = useState(false);
    const [lists, setLists] = useState({
        all: [] as sciClassInterface[],
        pending: [] as sciClassInterface[],
        active: [] as sciClassInterface[],
    });
    const [search, setSearch] = useState('');
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/parents/center/class-list',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                all: sciClassInterface[] | null,
                pending: sciClassInterface[] | null,
                active: sciClassInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setLoaded(true);
                let all = d.all === null ? [] : d.all;
                if (d.pending !== null) {
                    d.pending.forEach(p => {
                        const i = all.findIndex(e => e.nd === p.nd);
                        if (i > -1)
                            all.splice(i, 1);
                    });
                }
                if (d.active !== null) {
                    d.active.forEach(p => {
                        const i = all.findIndex(e => e.nd === p.nd);
                        if (i > -1)
                            all.splice(i, 1);
                    });
                }
                setLists({
                    all: all,
                    pending: d.pending === null ? [] : d.pending,
                    active: d.active === null ? [] : d.active,
                });
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "کلاس فوق برنامه | نهال";
        fetchData();
    }, []);
    useEffect(() => {
        if (!loaded)
            return;
        const filter = search.toUpperCase().trim();
        const lst = document.querySelector('.sci-class-list');
        const btns = (lst as HTMLDivElement).getElementsByTagName('a');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('b')[0];
            if (typeof b === 'undefined')
                continue;
            const v = b.innerHTML.toUpperCase();
            const noSpace = v.replaceAll(' ', '');
            if (v.indexOf(filter) > -1 || noSpace.indexOf(filter.replaceAll(' ', '')) > -1)
                //@ts-ignore
                btns[i].parentElement.style.display = "";
            else //@ts-ignore
                btns[i].parentElement.style.display = "none";
        }
    }, [search]);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'کلاس فوق برنامه', url: '/students/center'},
            ]}/>
            <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                <div className="sci-class-list">
                    <b>کلاس‌های فوق برنامه</b>
                    <div className="pick-device-search">
                        <button><SearchIcon/></button>
                        <input type="text"
                               value={search}
                               onChange={e => setSearch(e.currentTarget.value)}
                               onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                               onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                               className="f-roboto"
                               placeholder={"جستجوی کلاس‌ها..."}
                        />
                    </div>
                    <b>کلاس‌های جدید</b>
                    <div className="row">
                        {
                            lists.all.length < 1 ? <span>کلاس جدیدی یافت نشد.</span> :
                                (lists.all.map((c, i) =>
                                    <ScienceCenterClassCard
                                        key={"K3jdJjDKKdKKK222" + i}
                                        data={c}
                                        mode={'new'}
                                    />
                                ))
                        }
                    </div>
                    {
                        lists.pending.length > 0 ?
                            <>
                                <hr/>
                                <b>کلاس‌های در انتظار تایید</b>
                                <div className="row">
                                    {
                                        lists.pending.map((c, i) =>
                                            <ScienceCenterClassCard
                                                key={"K3jdJjDKKdKKK2221" + i}
                                                data={c}
                                                mode={'pending'}
                                            />
                                        )
                                    }
                                </div>
                            </> : null
                    }
                    {
                        lists.active.length > 0 ?
                            <>
                                <hr/>
                                <b>کلاس‌های ثبت نام شده</b>
                                <div className="row">
                                    {
                                        lists.active.map((c, i) =>
                                            <ScienceCenterClassCard
                                                key={"K3jdJjDKKdKKK2223" + i}
                                                data={c}
                                                mode={'active'}
                                            />
                                        )
                                    }
                                </div>
                            </> : null
                    }
                </div>
            </div>
        </>
    );
};

export const ScienceCenterClassCard = (props: { data: sciClassInterface, mode: 'new' | 'pending' | 'active', isFromHome?:boolean }) => {
    let timer: any;
    const [timerText, setTimerText] = useState('۰۰:۰۰:۰۰');
    useEffect(() => {
        if (props.data.hasExpiration) {
            let endTime = new Date(props.data.expiresAt).getTime();
            timer = setInterval(() => {
                let now = new Date().getTime();
                let timeLeft = endTime - now;

                if (timeLeft <= 0) {
                    clearInterval(timer);
                    console.log("Countdown expired");
                    return;
                }

                let days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                let hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

                setTimerText(StringDigitsConvertToPersian((days < 1 ? '' : `${CurrencyFormat(days)} روز و `) + TimeFixToGoLayout(`${hours}:${minutes}:${seconds}`)));

            },1000);
        }
    }, []);
    return (
        <div className="col-lg-4 col-md-6">
            <Link to={`/students/center/class/` + props.data.nd}>
                {
                    props.data.hasExpiration && props.mode === 'new' ?
                        <small>
                            {timerText === '۰۰:۰۰:۰۰' ? 'منقضی شده' : timerText}
                            <ThinTimeIcon/>
                        </small> : null
                }
                <em style={{backgroundImage: `url(${ServerImage(props.data.img, 500)})`}}/>
                <b>{props.data.title}</b>
                <i>مربی: {props.data.teacher}</i>
                <p className="max-lines-2">{props.data.desc}</p>
                <div>
                    {props.mode === 'new' ? <i>{CurrencyFormat(props.data.price)}<TomansIcon/></i> : <i/>}
                    <strong>
                        {props.mode === 'new' ? 'ثبت نام' : 'مشاهده'}
                        <ChevronRightIcon/>
                    </strong>
                </div>
            </Link>
        </div>
    );
};